export enum TmsScriptModeEnum {
  SYNC = 'SYNC',
  ASYNC = 'ASYNC'
}
